import React from "react";

const EntriesSelector = ({ entriesPerPage, setEntriesPerPage, setCurrentPage }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "6px",          // spacing like screenshot
        fontSize: "10px",
        color: "#495057",
      }}
    >
      {/* <span>Show</span> */}

      <select
        value={entriesPerPage}
        onChange={(e) => {
          setEntriesPerPage(Number(e.target.value));
          setCurrentPage(1);
        }}
        style={{
          height: "30px",
          minWidth: "60px",
          padding: "3px 8px",
          fontSize: "13px",
          borderRadius: "4px",
          border: "1px solid #ced4da",
          outline: "none",
          backgroundColor: "#fff",
        }}
      >
        <option value={10}>10</option>
        <option value={50}>50</option>
        <option value={100}>100</option>
      </select>

      {/* <span>entries</span> */}
    </div>
  );
};

export default EntriesSelector;
